import styled from 'styled-components'

// Utils
import { breakpoint } from 'utils'

// Components
import Modal from 'components/Modal'
import Button from 'components/Button'
import OrderedBreadcrumbs from 'components/OrderedBreadcrumbs'
import Link from 'components/Link'
import VerificationCode from 'components/VerificationCode'

export const ModalBody = styled(Modal.Body)`
  ${breakpoint('base', 'xs')`
    margin: 0 24px 32px 24px;
  `}
`

export const StyledOrderedBreadcrumbs = styled(OrderedBreadcrumbs)`
  margin-top: 12px;
`

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  font-size: ${({ theme }) => theme.fontSizes.large};
  margin: 24px 0 8px 0;
`

export const Description = styled.p`
  margin-bottom: 16px;
`

export const Links = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledLink = styled(Link)`
  :not(:last-child) {
    margin-bottom: 16px;
  }
`

export const Code = styled.code`
  display: block;
  padding: 16px;
  margin-bottom: 16px;
  font-family: ${({ theme }) => theme.fonts.monospace};
  font-size: ${({ theme }) => theme.fontSizes.large};
  text-align: center;
  background-color: ${({ theme }) => theme.colors.background.secondary[2]};
`

export const StyledVerificationCode = styled(VerificationCode)`
  margin-bottom: 16px;
`

export const RecoveryCodes = styled.ul`
  text-align: center;
  margin: 0 0 24px 0;
  padding: 24px;
  border: 1px dashed ${({ theme }) => theme.colors.border[1]};
  border-radius: ${({ theme }) => theme.radii.xlarge};
  background-color: ${({ theme }) => theme.colors.background.secondary[2]};
  list-style: none;
  columns: 2;
`

export const RecoveryCode = styled.li`
  display: block;
  font-family: ${({ theme }) => theme.fonts.monospace};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  font-size: ${({ theme }) => theme.fontSizes.body};

  :not(:last-child, :nth-child(4)) {
    padding-bottom: 24px;
  }
`

export const Buttons = styled.div`
  display: flex;
  margin-bottom: 16px;
`

export const StyledButton = styled(Button)`
  flex: 1;
`

export const QRCode = styled.div`
  display: flex;
  margin-bottom: 16px;
`

export const Image = styled.div`
  width: 144px;
  height: 144px;
  background: gray; /* Placeholder Remove when QR COde image is available*/
  flex: 1 0 144px; /* Dont let the QR Code get squished */
`

export const List = styled.ol`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 16px 0;
`

export const Item = styled.li`
  :not(:last-child) {
    margin-bottom: 20px;
  }
`
